// extracted by mini-css-extract-plugin
module.exports = {"CompareButton":"CompareButton_CompareButton__yK2gn","count":"CompareButton_count__oQG5Y"};